const loadImage = (url, onLoad, onError) => {
  const image = new Image();
  image.crossOrigin = 'Anonymous';
  image.src = url;

  image.onload = onLoad;
  image.onerror = onError;
};

export default loadImage;
